module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.f4769f9b.eot";


//////////////////
// WEBPACK FOOTER
// ./html/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 385
// module chunks = 0